import { addIndex, isEmpty, join, map, pipe, reject } from 'ramda';

export const mapIndexed = addIndex(map);

export const filterNonEmpty = reject(isEmpty);

export const mapAndJoin = (fn, items) => pipe(map(fn), join(','))(items);
